<template>
  <div class="para" style="margin-top: 0">
    <p class="lead">
      対象機能：<span style="font-weight: bold">{{ titleName }}</span>
    </p>
    <p class="lead">
      対象機能を利用可能なユーザを指定してください。グループまたはユーザのいずれかが許可されている場合に利用可能となります。
    </p>
    <div class="frm-row">
      <div class="frm-item grow left">
        <p class="errMsg title-ico ico-warning" v-show="errors.length > 0">
          <ErrorMessage :errors="errors"></ErrorMessage>
        </p>
      </div>
    </div>
    <!-- swap -->
    <div class="swap-row" style="margin-top: 0px">
      <div class="swap-left">
        <h3 class="h4">利用を許可する利用者の登録</h3>
        <div class="frm-row">
          <div
            class="frm-search frm-size-xl"
            :class="[searchKeyPermission ? 'setvalue' : '']"
          >
            <span class="frm-label">
              &nbsp;
              <img src="@/assets/images/TDSDC/icon_search.png" />
            </span>
            <input
              type="search"
              class="frm-search-text"
              placeholder="検索キーワード"
              maxlength="255"
              ref="searchIndex"
              @change="setFilter"
              v-model.trim="searchKeyPermission"
              tabindex="8"
            />
          </div>
        </div>
        <div class="frm-item alignright">
          <p>{{ permissionCount }}</p>
        </div>
        <!-- table -->
        <div class="table-wrap" style="margin-top: 0px">
          <div class="table-scroll-header">
            <table class="table-select multi-select">
              <colgroup>
                <col style="width: 40px" />
                <col style="width: 170px" />
                <col style="width: auto" />
                <col style="width: 110px" />
              </colgroup>
              <thead>
                <tr>
                  <!-- 全選択解除 -->
                  <th class="multi-select-item aligncenter">
                    <label class="frm-checkbox">
                      <input
                        type="checkbox"
                        :checked="isAllSelectedPermission"
                        @click="selectAllRowPermission(isAllSelectedPermission)"
                        :disabled="
                          sortPermissionList.every((e) => !e.enabled) ||
                          sortPermissionList.length === 0
                        "
                      />
                      <span
                        class="checkbox-item"
                        :tabindex="
                          sortPermissionList.every((e) => !e.enabled) ||
                          sortPermissionList.length === 0
                            ? 0
                            : 12
                        "
                        @keydown.space.stop.prevent="
                          selectAllRowPermission(isAllSelectedPermission)
                        "
                      ></span>
                    </label>
                  </th>
                  <th
                    class="sort hover alignleft"
                    @click="sortPermissionData('id')"
                  >
                    ログインID/
                    <br />グループコード
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sortPermission.key == 'id' && sortPermission.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sortPermission.key == 'id' && !sortPermission.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th
                    class="sort hover alignleft"
                    @click="sortPermissionData('name')"
                  >
                    利用者名/グループ名
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sortPermission.key == 'name' && sortPermission.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sortPermission.key == 'name' && !sortPermission.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th
                    class="sort hover"
                    @click="sortPermissionData('authority')"
                  >
                    権限
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sortPermission.key == 'authority' &&
                          sortPermission.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sortPermission.key == 'authority' &&
                          !sortPermission.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="table-scroll-body h-395px">
            <table class="table-select multi-select">
              <colgroup>
                <col style="width: 40px" />
                <col style="width: 170px" />
                <col style="width: auto" />
                <col style="width: 110px" />
              </colgroup>
              <tbody>
                <tr
                  v-for="info in sortPermissionList"
                  :key="info.id"
                  @click="selectRow(info)"
                  :class="{
                    selected: info.selected,
                    disabled: !info.enabled,
                  }"
                >
                  <!-- 選択 -->
                  <td class="multi-select-item aligncenter">
                    <label
                      class="frm-checkbox"
                      @keydown.space.stop.prevent="selectRow(info)"
                    >
                      <!-- 収集方法が対象外の場合は非活性-->
                      <input
                        type="checkbox"
                        :checked="info.selected"
                        @click="selectRow(info)"
                        :disabled="info.enabled == false"
                      />
                      <span
                        class="checkbox-item"
                        :tabindex="info.enabled == false ? 0 : 12"
                      ></span>
                    </label>
                  </td>
                  <td
                    class="group"
                    :class="{
                      'ico-folder': info.icon,
                      'ico-user': !info.icon,
                    }"
                  >
                    <span>{{ info.id }}</span>
                  </td>
                  <td>
                    <span>{{ info.name }}</span>
                  </td>
                  <td class="aligncenter">
                    <span>
                      {{ accessAuthFormat(info.authority) }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              class="table-select single-select"
              style="background: #fff"
              v-show="sortPermissionList.length === 0"
            >
              <tbody>
                <tr>
                  <p class="noData-area">
                    {{ noDataMsg }}
                  </p>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- table // -->
      </div>
      <div class="swap-center">
        <div class="swap-btn-col">
          <button
            class="swap-btn permission"
            type="button"
            @click="handlePermission"
            :disabled="!sortDeniedList.some((e) => e.selected)"
            tabindex="12"
          >
            許可
          </button>
          <button
            class="swap-btn rejection"
            type="button"
            @click="handleDenied"
            :disabled="!sortPermissionList.some((e) => e.selected)"
            tabindex="12"
          >
            拒否
          </button>
        </div>
      </div>
      <div class="swap-right">
        <!-- <h3 class="h4">利用者一覧</h3> -->
        <div class="frm-row　mt-45px">
          <div
            class="frm-search frm-size-xl"
            :class="searchKeyDenied ? 'setvalue' : ''"
          >
            <span class="frm-label" style="margin-left: 0.5em">
              <img src="@/assets/images/TDSDC/icon_search.png" />
            </span>
            <input
              type="search"
              class="frm-search-text"
              placeholder="検索キーワード"
              maxlength="255"
              @change="setFilter"
              v-model.trim="searchKeyDenied"
              tabindex="12"
            />
          </div>
        </div>

        <!-- table -->
        <div class="frm-item alignright">
          <p>{{ deniedCount }}</p>
        </div>
        <div class="table-wrap" style="margin-top: 0px">
          <div class="table-scroll-header">
            <table class="table-select scroll">
              <colgroup>
                <col style="width: 40px" />
                <col style="width: 170px" />
                <col style="width: auto" />
                <col style="width: 110px" />
              </colgroup>
              <thead>
                <tr>
                  <!-- 全選択解除 -->
                  <th class="multi-select-item aligncenter">
                    <label class="frm-checkbox">
                      <input
                        type="checkbox"
                        :checked="isAllSelectedDenied"
                        @click="selectAllRowDenied(isAllSelectedDenied)"
                        :disabled="sortDeniedList.length === 0"
                      />
                      <span
                        class="checkbox-item"
                        :tabindex="sortDeniedList.length === 0 ? 0 : 12"
                        @keydown.space.stop.prevent="
                          selectAllRowDenied(isAllSelectedDenied)
                        "
                      ></span>
                    </label>
                  </th>
                  <th
                    class="sort hover alignleft"
                    @click="sortDeniedData('id')"
                  >
                    ログインID/
                    <br />グループコード
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sortDenied.key == 'id' && sortDenied.isAsc ? 'on' : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sortDenied.key == 'id' && !sortDenied.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th
                    class="sort hover alignleft"
                    @click="sortDeniedData('name')"
                  >
                    利用者名/グループ名
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sortDenied.key == 'name' && sortDenied.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sortDenied.key == 'name' && !sortDenied.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                  <th class="sort hover" @click="sortDeniedData('authority')">
                    権限
                    <div class="sort-toggle">
                      <button
                        class="sort-toggle-asc"
                        :class="
                          sortDenied.key == 'authority' && sortDenied.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        asc
                      </button>
                      <button
                        class="sort-toggle-desc"
                        :class="
                          sortDenied.key == 'authority' && !sortDenied.isAsc
                            ? 'on'
                            : ''
                        "
                        type="button"
                      >
                        desc
                      </button>
                    </div>
                  </th>
                </tr>
              </thead>
            </table>
          </div>
          <div class="table-scroll-body h-395px">
            <table class="table-select scroll">
              <colgroup>
                <col style="width: 40px" />
                <col style="width: 170px" />
                <col style="width: auto" />
                <col style="width: 110px" />
              </colgroup>
              <tbody>
                <tr
                  v-for="info in sortDeniedList"
                  :key="info.id"
                  @click="selectRow(info)"
                  :class="{
                    selected: info.selected,
                    disabled: !info.enabled,
                  }"
                >
                  <!-- 選択 -->
                  <td class="multi-select-item aligncenter">
                    <label
                      class="frm-checkbox"
                      @keydown.space.stop.prevent="selectRow(info)"
                    >
                      <!-- 収集方法が対象外の場合は非活性-->
                      <input
                        type="checkbox"
                        :checked="info.selected"
                        @click="selectRow(info)"
                        :disabled="!info.enabled"
                      />
                      <span
                        class="checkbox-item"
                        :tabindex="!info.enabled ? 0 : 12"
                      ></span>
                    </label>
                  </td>
                  <td
                    class="group"
                    :class="{
                      'ico-folder': info.icon,
                      'ico-user': !info.icon,
                    }"
                  >
                    <span>{{ info.id }}</span>
                  </td>
                  <td>
                    <span>{{ info.name }}</span>
                  </td>
                  <td class="aligncenter">
                    <span>
                      {{ accessAuthFormat(info.authority) }}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
            <table
              class="table-select single-select"
              style="background: #fff"
              v-show="sortDeniedList.length === 0"
            >
              <tbody>
                <tr>
                  <p class="noData-area">
                    {{ noDataMsg }}
                  </p>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- table // -->
      </div>
    </div>
    <!-- swap // -->
    <!-- ******************************************************************
               *  下部ボタン群                                                  *
          ******************************************************************-->
    <div class="frm-btn-row footer-btn">
      <div class="frm-item grow center">
        <button
          class="frm-btn strong large"
          type="button"
          :disabled="isRegisterBtnDisabled"
          @click="handleAdd"
          tabindex="17"
        >
          確定
        </button>
        <button
          class="frm-btn large"
          type="button"
          @click="cancelAdd"
          tabindex="18"
        >
          キャンセル
        </button>
      </div>
    </div>
    <ConfirmDialog
      :isShow="showConfirmDialog"
      :message="Common.getMessage('MTCL2001', [])"
      @confirm="toNextPage"
      @cancel="cancelToNextPage"
    ></ConfirmDialog>
  </div>
</template>

<script setup>
//#region  インポート
import { useRouter, onBeforeRouteLeave } from "vue-router";
import { ref, computed, reactive, onMounted, nextTick } from "vue";
import moment from "moment";
import Common from "@/util/common.js";
import HeaderNav from "@/components/AccountingHeader.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import { useStore } from "vuex";
import { ACCESS_AUTH } from "@/util/enum.js";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import {
  API_DisplayAccessAuthorityList,
  API_AccessAuthorityChange,
} from "@/api/Modules/DC05/STDSDC05C06";
//#endregion

//#region 変数定義
const functionAuthorityKeyName = ref($cookies.get("05C05_functionName"));
const titleName = ref($cookies.get("05C05_name"));
const personInChargeList = ref([]);
const authorityInfoList = ref([]);
const searchKeyDenied = ref("");
const searchKeyPermission = ref("");
const errorsList = ref([]);
const router = useRouter();
const store = useStore();
const isRegisterBtnDisabled = ref(false);
const addFlg = ref(false);
const noDataMsg = ref(Common.getMessage("MTCL1118", ["利用者"]));
const sortPermission = reactive({
  key: "", // ソートキー
  isAsc: true, // 昇順ならtrue,降順ならfalse
});
const sortDenied = reactive({
  key: "", // ソートキー
  isAsc: true, // 昇順ならtrue,降順ならfalse
});
//#endregion

//#region　計算
//エラーメッセージ
const errors = computed(() => {
  const subErrorList = store.getters["securityModule/getErrorStatus"]
    ? store.getters["securityModule/getErrors"]
    : [];
  return [...subErrorList, ...errorsList.value];
});

// 許可リストのソート
const sortPermissionList = computed(() => {
  let list = authorityInfoList.value.filter((e) => e.permission);

  //検索キーワード
  list = list.filter((item) => {
    return (
      item.id.includes(searchKeyPermission.value) ||
      item.name.includes(searchKeyPermission.value) ||
      accessAuthFormat(item.authority).includes(searchKeyPermission.value)
    );
  });

  list = Common.listSort(sortPermission.key, sortPermission.isAsc, list);

  return list;
});

// 拒否リストのソート
const sortDeniedList = computed(() => {
  let list = authorityInfoList.value.filter((e) => !e.permission);

  //検索キーワード
  list = list.filter((item) => {
    return (
      item.id.includes(searchKeyDenied.value) ||
      item.name.includes(searchKeyDenied.value) ||
      accessAuthFormat(item.authority).includes(searchKeyDenied.value)
    );
  });

  list = Common.listSort(sortDenied.key, sortDenied.isAsc, list);

  return list;
});

//利用を許可するユーザ 件数
const permissionCount = computed(() => {
  const total = authorityInfoList.value.filter((e) => e.permission).length;
  return searchKeyPermission.value
    ? `${sortPermissionList.value.length.toLocaleString()}/${total.toLocaleString()}件`
    : `${total.toLocaleString()}件`;
});

//利用者一覧  件数
const deniedCount = computed(() => {
  const total = authorityInfoList.value.filter((e) => !e.permission).length;
  return searchKeyDenied.value
    ? `${sortDeniedList.value.length.toLocaleString()}/${total.toLocaleString()}件`
    : `${total.toLocaleString()}件`;
});

const isAllSelectedPermission = computed(() => {
  return (
    sortPermissionList.value.every((e) => !e.enabled) ||
    sortPermissionList.value
      .filter((e) => e.enabled)
      .every((info) => info.selected)
  );
});
const isAllSelectedDenied = computed(() => {
  return (
    sortDeniedList.value.every((e) => !e.enabled) ||
    sortDeniedList.value.filter((e) => e.enabled).every((info) => info.selected)
  );
});

const isMultiCheckboxDisable = computed(() => {
  return (
    sortDeniedList.value.every((e) => !e.enabled) ||
    sortDeniedList.value.filter((e) => e.enabled).every((info) => info.selected)
  );
});
//#endregion

// アクセス権限フォーマット
const accessAuthFormat = (data) => {
  // グループ
  if (data == ACCESS_AUTH.group.code) {
    return ACCESS_AUTH.group.text;
  }
  // 管理者
  else if (data == ACCESS_AUTH.admin.code) {
    return ACCESS_AUTH.admin.text;
  }
  // 管理ユーザー
  else if (data == ACCESS_AUTH.adminUser.code) {
    return ACCESS_AUTH.adminUser.text;
  }
  // 一般ユーザー
  else if (data == ACCESS_AUTH.generalUser.code) {
    return ACCESS_AUTH.generalUser.text;
  }
};

//一覧データを取得
const getList = () => {
  store.commit("businessModule/processDialogue", true);
  const params = ref({
    FunctionAuthorityKeyName: functionAuthorityKeyName.value,
  });

  return API_DisplayAccessAuthorityList(params.value)
    .then((response) => {
      if (response.result == "0000") {
        personInChargeList.value = [...response.authorityInfoList].filter(
          (e) => !e.icon
        );
        authorityInfoList.value = response.authorityInfoList.filter(
          (val) => val.permission === true && val.id != ""
        );
        authorityInfoList.value = response.authorityInfoList
          .filter((val) => val.id != "")
          .map((e) => {
            return { ...e, selected: false };
          });

        // アクセス権限許可ユーザリストの選択リスト初期化
        authorityInfoList.value.forEach((value, index, array) => {
          // ソート用にシーケンスを付与
          if (array[index].icon) {
            array[index].sortSequence = 0;
          } else {
            array[index].sortSequence = 1;
          }
        });
      } else {
        // エラー表示
        errors.value.push(
          Common.createError(
            response.errorCD,
            Common.getMessage(response.errorCD, [])
          )
        );
      }
      store.commit("businessModule/processDialogue", false);
    })
    .catch((error) => {
      console.log(error);
      store.commit("businessModule/processDialogue", false);
    })
    .finally(() => {
      // 初期フォーカス設定(検索キーワード)
      // nextTick(() => searchIndex.value.focus());
      nextTick(() => {
        initFocus();
      });
    });
};

// 許可ボタン押下時
const handlePermission = () => {
  //検索キーワード
  sortDeniedList.value
    .filter((e) => e.selected)
    .forEach((e) => {
      e.permission = true;
      e.selected = false;
    });
};

// 拒否ボタン押下時
const handleDenied = () => {
  //検索キーワード
  sortPermissionList.value
    .filter((e) => e.selected)
    .forEach((e) => {
      e.permission = false;
      e.selected = false;
    });
};

// 全行選択時の処理
const selectAllRowDenied = (status) => {
  if (status) {
    sortDeniedList.value
      .filter((e) => e.enabled)
      .forEach((info) => {
        // if (info.status != 99) {
        info.selected = false;
        // }
      });
  } else {
    sortDeniedList.value
      .filter((e) => e.enabled)
      .forEach((info) => {
        // if (info.status != 99) {
        info.selected = true;
        // }
      });
  }
};

// 全行選択時の処理
const selectAllRowPermission = (status) => {
  if (status) {
    sortPermissionList.value
      .filter((e) => e.enabled)
      .forEach((info) => {
        // if (info.status != 99) {
        info.selected = false;
        // }
      });
  } else {
    sortPermissionList.value
      .filter((e) => e.enabled)
      .forEach((info) => {
        // if (info.status != 99) {
        info.selected = true;
        // }
      });
  }
};

// 行選択
const selectRow = (info) => {
  // 管理権限ユーザー以外の場合
  if (info.enabled) {
    info.selected = !info.selected;
  }
};

const sortPermissionData = (key) => {
  // isAsc 昇順ならtrue,降順ならfalse
  sortPermission.isAsc =
    sortPermission.key === key ? !sortPermission.isAsc : true;
  sortPermission.key = key;
};

const sortDeniedData = (key) => {
  // isAsc 昇順ならtrue,降順ならfalse
  sortDenied.isAsc = sortDenied.key === key ? !sortDenied.isAsc : true;
  sortDenied.key = key;
};

const handleAdd = () => {
  // 登録パラメータ
  const tempList = ref([]);
  authorityInfoList.value.forEach((item) => {
    if (item.permission) {
      const keyNametpye = ref(0);
      if (item.authority == 0) {
        keyNametpye.value = 1;
      }
      tempList.value.push({
        KeyNameType: keyNametpye.value,
        KeyName: item.keyName,
        Id: item.iD,
        Name: item.name,
      });
    }
  });
  const param = {
    FunctionAuthorityKeyName: functionAuthorityKeyName.value,
    SettingMode: 1,
    UserList: tempList.value,
    SettingUpdateDate: moment(),
  };

  // 登録ボタン 非活性化
  isRegisterBtnDisabled.value = true;
  API_AccessAuthorityChange(param).then((response) => {
    if (response.result == "0000") {
    } else {
      // エラー表示
      errors.value.push(
        Common.createError(
          response.errorCD,
          Common.getMessage(response.errorCD, [])
        )
      );
    }
  });
  // 登録ボタン 活性化
  isRegisterBtnDisabled.value = false;
  addFlg.value = true;
  router.push({ name: "STDSDC05C05" });
};
const cancelAdd = () => {
  showConfirmDialog.value = false;
  router.push({ name: "STDSDC05C05" });
};
//画面初期化
const searchIndex = ref(null);
const initFocus = () => {
  searchIndex.value.focus();
};
onMounted(() => {
  // 初期フォーカス設定(検索キーワード)
  //nextTick(() => searchIndex.value.focus());
  // エラーメッセージを初期化
  store.commit("securityModule/updateErrors", []);
  getList();
});

const showConfirmDialog = ref(false);
let targetRoute = "";
onBeforeRouteLeave((to, from, next) => {
  // 画面遷移チェック
  if (!$cookies.get("SessionID") || to.name == "STDSCM04C06" || targetRoute) {
    next();
  } else {
    targetRoute = to;
    if (addFlg.value) {
      next();
    } else {
      showConfirmDialog.value = true;
    }
  }
});
const toNextPage = () => {
  router.push(targetRoute);
};
const cancelToNextPage = () => {
  showConfirmDialog.value = false;
  targetRoute = "";
};
</script>
<style scoped>
.table-wrap .table-select td{
  height: 60px;
}
</style>
